import { render, staticRenderFns } from "./SubscriptionPlanDetails.vue?vue&type=template&id=56cd50ca"
import script from "./SubscriptionPlanDetails.vue?vue&type=script&lang=js"
export * from "./SubscriptionPlanDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports